import { PanelLeftExpand20Regular } from '@/components/Icon'
import styles from './SecondaryNavHeaderTitle.module.scss'

export default function SecondaryNavHeaderCollapsed({ onToggleCollapse }) {
  return (
    <div className={`${styles.headerRow} ${styles.headerRowCollapsed}`} data-nav-chrome>
      <button
        type="button"
        className={styles.collapseButton}
        aria-label="Expand panel"
        onClick={onToggleCollapse}
      >
        <PanelLeftExpand20Regular aria-hidden />
      </button>
    </div>
  )
}
